// extracted by mini-css-extract-plugin
export default {"checker":"checkbox_checker__2NBfV"};